import State from '../interfaces/states/ActivityState';

import * as Const from '../constants';

const initState: State = {
  activityData: {
    data: [],
  },
  isLoading: false,
  isError: false,
  years: ['2019', '2018', '2017'],
  months: [
    { label: 'Jan', num: 0, active: false },
    { label: 'Feb', num: 1, active: false },
    { label: 'Mar', num: 2, active: false },
    { label: 'Apr', num: 3, active: false },
    { label: 'May', num: 4, active: false },
    { label: 'Jun', num: 5, active: false },
    { label: 'Jul', num: 6, active: false },
    { label: 'Aug', num: 7, active: false },
    { label: 'Sep', num: 8, active: false },
    { label: 'Oct', num: 9, active: false },
    { label: 'Nov', num: 10, active: false },
    { label: 'Dec', num: 11, active: false }],
  allDays: [1, 2, 3, 4, 5, 6, 7, 8],
  currentYear: '2019',
  currentMonth: { label: 'Jan', num: 0 },
  currentDay: null,
};

export default function activity (state: State = initState, action): State {
  switch (action.type) {

    case Const.FETCH_ACTIVITY_INIT:
      return {
        ...initState,
      };

    case Const.FETCH_ACTIVITY_PENDING:
      return {
        ...state,
        isLoading: true,
        isError: false,
      };

    case Const.FETCH_ACTIVITY_ERROR:
      return {
        ...state,
        isError: true,
        isLoading: false,
      };

    case Const.FETCH_ACTIVITY_SUCCESS:
      return {
        ...state,
        activityData: action.payload,
        isLoading: false,
        isError: false,
      };

    case Const.FETCH_ACTIVITY_YEAR:
      return {
        ...state,
        currentYear: action.payload,
      };

    case Const.FETCH_ACTIVITY_MONTH:
      return {
        ...state,
        currentMonth: action.payload,
      };

    case Const.FETCH_ACTIVITY_CURRENT_DAY:
      return {
        ...state,
        currentDay: action.payload,
      };

    default:
      return state;
  }
}
